module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/cover-3-0d8dd6bfb90bc890a9a07418f9865eef.webp";